<template>
  <div class="vch-product-testing-form">
    <div class="vch-product-testing-form-title">
      <h1 class="vch-product-testing-form__title heading-xl uppercase">
        {{ currentTitle }}
        <!-- <span class="heading-xl mb-xl sub-heading"> {{ titleSecondary }}</span> -->
      </h1>
    </div>
    <template v-if="!formSuccess">
      <div class="vch-grid">
        <div class="vch-col-12 vch-col-md-10 vch-col-lg-10 vch-col-xl-8">
          <!-- <p class="vch-contact-form__instructions">
            {{ formMandatoryInstruction }}
          </p> -->
          <div class="vch-product-testing-form__column">
            <div class="vch-product-testing-form__imgblock">
              <picture>
                <source
                  key="420"
                  :srcset="formImageSrc"
                  media="(min-width: 1024px)"
                />
                <source
                  key="728"
                  :srcset="formMobileImageSrc"
                  media="(min-width: 425px)"
                />
                <img key="350" alt="" :src="formMobileImageSrc" />
              </picture>
            </div>
            <slot name="form">Form Here</slot>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="vch-product-testing-form__column">
        <div class="vch-product-testing-form__imgblock --success">
          <picture>
            <source
              key="420"
              :srcset="formImageSrc"
              media="(min-width: 1024px)"
            />
            <source
              key="728"
              :srcset="formMobileImageSrc"
              media="(min-width: 425px)"
            />
            <img key="350" alt="" :src="formMobileImageSrc" />
          </picture>
        </div>
        <div class="successform">
          <h2 class="heading-lg uppercase mb-xxs">
            <span class="heading-lg-em">{{ completeTitlePrimary }}</span
            ><br />{{ confirmTitleSecondary }}
          </h2>
          <p class="heading-md mb-xl" v-html="completeMessage"></p>
          <a
            href="/"
            class="button -primary --fit-content"
            @click="pushReturnTag"
            >{{ confirmButtonText }}</a
          >
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { parseSitecoreForm, bindFormField } from 'Utils/form';
import { pushEvent } from 'Utils/datalayer';
import { mixinFormRecaptcha } from 'Mixins/formRecaptcha/formRecaptcha';

export default {
  name: 'product-testing-form',
  mixins: [mixinFormRecaptcha],
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    formMandatoryInstruction: {
      type: String,
    },
    titleSubheading: {
      type: String,
      required: true,
    },
    testHost: {
      type: String,
      required: false,
    },
    confirmTitlePrimary: {
      type: String,
      required: true,
    },
    confirmTitleSecondary: {
      type: String,
      required: true,
    },
    confirmMessage: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    errorMessageFormIncomplete: {
      type: String,
      required: false,
    },
    defaultErrorMessage: {
      type: String,
      required: false,
      default: 'An error occured while processing your request.',
    },
    formImageSrc: {
      type: String,
      required: false,
    },
    formMobileImageSrc: {
      type: String,
      required: false,
    },
    requiredErrorMessage: {
      type: String,
      required: false,
      default: 'Atleast 1 should be selected.',
    },
    formDatalayer: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentTitle: this.formTitle,
      titleSecondary: this.titleSubheading,
      formSuccess: false,
      useEmailFlow: false,
      fields: [],
      formProperties: null,
      parser: new DOMParser(),
      showError: false,
      datalayerForm: null,
    };
  },
  computed: {
    completeTitleSecondary() {
      return this.titleSecondary;
    },
    completeTitlePrimary() {
      return this.confirmTitlePrimary;
    },
    completeMessage() {
      return this.confirmMessage;
    },
    formActionUrl() {
      return process.env.NODE_ENV === 'production'
        ? this.formProperties.formAction
        : `${this.testHost}${this.formProperties.formAction}`;
    },
  },
  mounted() {
    const formNode = this.$slots.form[0].children[0].children[0];
    if (!formNode?.elm) {
      return;
    }
    // Collect the base form properties and hijack form submit
    this.formProperties = parseSitecoreForm(formNode?.elm);
    formNode.elm.addEventListener('submit', this.onSubmit);

    // Create the error message wrapper
    this.errorWrapperNode = document.createElement('div');
    this.errorWrapperNode.setAttribute('role', 'status');
    this.errorWrapperNode.classList.add('vch-contact-form__errorSummary');
    const submitButton = formNode?.elm.querySelector('input[type="submit"]');
    submitButton.parentNode.insertBefore(this.errorWrapperNode, submitButton);
    formNode.children
      .filter((node) => node.tag === 'div' || node.tag === 'input')
      .forEach((node) => {
        const foundFieldInfo = bindFormField(node);
        if (foundFieldInfo.nestedFieldInfo.length) {
          this.fields.push(...foundFieldInfo.nestedFieldInfo);
        }
        this.fields.push(foundFieldInfo);
      });
    this.initializeCheckboxSelection();
    this.datalayerForm = JSON.parse(this.formDatalayer);
  },

  methods: {
    async onSubmit(e) {
      e.preventDefault();
      if (!this.validateForm()) {
        return; // Validation failed, so prevent form submission
      }
      let submitButton = document.querySelector('.vch-form-submit');
      //Recaptcha Flow via Mixin
      this.peformRecaptcha()
        .then(async (canSubmit) => {
          if (canSubmit) {
            if (submitButton) {
              submitButton.setAttribute('disabled', 'disabled');
            }
            await fetch(this.formActionUrl, {
              method: 'POST',
              mode: process.env.NODE_ENV === 'production' ? 'cors' : 'no-cors',
              body: this.assembleFormData(),
            })
              .then((response) => {
                if (response.status >= 400 && response.status < 600) {
                  throw new Error(this.defaultErrorMessage);
                }
                return response.text();
              })
              .then((response) => {
                const htmlResponse = this.parser.parseFromString(
                  response,
                  'text/xml'
                );
                const errorWrapper = htmlResponse.querySelector(
                  '.validation-summary-errors'
                );
                if (errorWrapper) {
                  const serverErrorMsgs = errorWrapper.querySelectorAll('li');
                  const summaryErrors = Array.from(serverErrorMsgs).map(
                    (msg) => msg.textContent
                  );
                  this.setErrorMessage(summaryErrors[0]);
                  if (submitButton) {
                    submitButton.removeAttribute('disabled');
                  }
                } else {
                  this.formSuccess = true;
                  this.pushSubmitTags();
                  setTimeout(() => {
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }, 100);
                }
              })
              .catch((error) => {
                this.setErrorMessage(error.message);
                if (submitButton) {
                  submitButton.removeAttribute('disabled');
                }
              });
          }
        })
        .catch(() => {
          this.setErrorMessage(this.defaultErrorMessage);
          if (submitButton) {
            submitButton.setAttribute('disabled', 'disabled');
          }
        });
    },
    setErrorMessage(errorMessage) {
      this.errorWrapperNode.innerText = errorMessage;
    },
    initializeCheckboxSelection() {
      // Find all checkbox inputs within .vch-form-element-ans elements
      const checkboxElements = this.$el.querySelectorAll(
        '.vch-product-testing-form .vch-form-element-ans input[type="checkbox"]'
      );
      checkboxElements.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleCheckboxSelection);
      });
    },
    handleCheckboxSelection(event) {
      const target = event.target;
      const checkboxes = target
        .closest('.vch-form-element-ans')
        .querySelectorAll('input[type="checkbox"]');

      // Count how many checkboxes are checked
      const checkedCount = Array.from(checkboxes).filter(
        (checkbox) => checkbox.checked
      ).length;

      // Maximum allowed checkboxes
      const maxCheckboxes = 3;

      checkboxes.forEach((checkbox) => {
        if (checkedCount >= maxCheckboxes && !checkbox.checked) {
          // If the maximum is reached and a checkbox is unchecked, enable it
          checkbox.disabled = true;
        } else {
          // If more than the maximum are checked, disable them
          checkbox.disabled = false;
        }
      });
    },
    validateForm() {
      const formElements = document.querySelectorAll(
        '.vch-product-testing-form .vch-form-element-ans'
      );
      let allChecked = true;

      formElements.forEach((element) => {
        const checkboxesOrRadios = element.querySelectorAll(
          'input[type="checkbox"], input[type="radio"]'
        );
        element.querySelector('[data-valmsg-for]').innerHTML = '';
        let isChecked = false;

        checkboxesOrRadios.forEach((input) => {
          if (input.checked) {
            isChecked = true;
          }
        });

        if (!isChecked) {
          element.querySelector('[data-valmsg-for]').innerHTML =
            this.requiredErrorMessage;
          allChecked = false;
        }
      });

      return allChecked;
    },
    assembleFormData() {
      const formData = new FormData();
      this.fields.forEach((field) => {
        if (field.inputElement) {
          formData.append(field.inputElement.name, field.inputElement.value);
        }
        field.hiddenFields.forEach((hiddenField) => {
          if (hiddenField.name) {
            formData.append(hiddenField.name, hiddenField.value);
          }
        });
      });
      const formDataInfo = document.querySelectorAll(
        '.vch-product-testing-form .vch-form-element-ans'
      );
      formDataInfo.forEach((element) => {
        let inputData = '';
        let inputName = '';
        const checkboxesRadios = element.querySelectorAll(
          'input[type="checkbox"], input[type="radio"]'
        );
        //const subQuestions = element.querySelector('.data-question');
        checkboxesRadios.forEach((input) => {
          if (input.checked) {
            inputName = input.name;
            inputData = inputData + input.value + '|';
          }
        });
        if (inputData !== '') {
          formData.delete(inputName);
          formData.append(inputName, inputData);
        }
      });
      return formData;
    },
    pushReturnTag() {
      pushEvent({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'appendix',
        eventAction: 'select::vch-product-testing-form',
        eventLabel: `${this.confirmButtonText.toLowerCase()}::${
          window.location.origin
        }`,
        event_name: 'body_button_click',
        cta_name: `${this.confirmButtonText.toLowerCase()}`,
        link_url: `${window.location.origin}`,
        module_name: 'vch-product-testing-form',
      });
    },
    pushSubmitTags() {
      pushEvent({
        event: this.datalayerForm?.data?.eventProperties?.event,
        event_name: this.datalayerForm?.data?.eventProperties?.event_name,
        ecommerce: this.datalayerForm?.data?.eventProperties?.ecommerce,
        eventCategory: this.datalayerForm?.data?.eventProperties?.eventCategory,
        eventAction: this.datalayerForm?.data?.eventProperties?.eventAction,
        eventLabel: this.datalayerForm?.data?.eventProperties?.eventLabel,
        quizz_type: this.datalayerForm?.data?.eventProperties?.quizz_type,
        quizz_name: this.datalayerForm?.data?.eventProperties?.quizz_name,
      });
    },
  },
};
</script>

<style lang="scss" src="./product-testing-form.scss"></style>
